module.exports = __webpack_public_path__ + "img/clip.f5f7f5e5.svg";